
// import Header from "./Header";
import FilterButton from "./FilterButton";
import GoogleMapReact from "google-map-react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import styled from '@emotion/styled';
import { ReactComponent as DownArrow } from '../assets/svgs/down-arrow.svg'; // Import your down arrow SVG icon
import { ReactComponent as MenuIcon } from '../assets/svgs/filters-map-menu.svg'; // Import the SVG icon
import mapMarker from '../assets/svgs/map-marker.svg';
import heart from '../assets/svgs/heart.svg';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TripPlanModal from "./TripPlanModal";
import FavoritesDropdown from './FavoritesDropdown';

const Container = styled.div`
  width: 100%;
  height:calc(100vh - 110px);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;

   /* Media Query for Mobile */
  @media (max-width: 768px) {
    height: 100vh; /* Full height on mobile */
    width: 100vw;
     margin-bottom: 0; /* Remove margin at the bottom on mobile */
  }
`;

const MapContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;

      /* Ensure MapContainer also takes full width/height on smaller screens */
  @media (max-width: 768px) {
    width: 100vw;  /* Full width on mobile */
    height: 100vh; /* Full height on mobile */
  }
`;


const OverlayContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 10px;
  right: 10px; /* Move the container to the right */
`;

const FavoriteButton = styled.button`
  position: absolute;
  bottom: 30px;
  left: 40px; /* Changed from right to left */
  padding: 10px 15px;
  background-color: #6895e3;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  cursor: pointer;
`;



const PlanYourTripButton = styled.button`
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  cursor: pointer;
  padding: 12px 12px;
  background: #385963;
  margin-top: 20px;
  align-self: flex-end; /* Moves it to the right inside the container */
  z-index: -1000;
  margin-right:20px;

    @media (max-width: 768px) {
    margin-top: 10px;
    font-size: 16px;
    }

  @media (max-width: 600px) {
    margin-top: 10px;
    font-size: 12px;
  }
`;

const FavoritesDropdownWrapper = styled.div`
  position: absolute;
  width: 200px;
  bottom: 90px;
  left: 40px;
  background: #6895e3;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  z-index: 100;
  color: white;
  gap: 10px;
  font-size:14px;
`;

const Favorites = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')}; /* Show or hide based on state */
  padding-left: 15px; /* Indent the favorites list */
  div {
    margin:10px;
    &:hover {
      color: white; /* Apply your desired hover color */
      transition: all 0.4s;
      font-weight: 500;
    }
  }
`;

const Category = styled.div`
  cursor: pointer;
  // margin-bottom: 5px;
   &:hover {
      font-weight: 700;
       transition: all 0.4s;
    }
`;

const DownArrowIcon = styled(DownArrow)`
  width: 16px; /* Set the width */
  height: 16px; /* Set the height */
  margin-left: 5px; /* Space between text and arrow */
`;

const FavoriteText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;


function MainMap() {

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const tokenString = sessionStorage.getItem("token");
  const loggedIn = sessionStorage.getItem("loggedIn");
  const userRole = sessionStorage.getItem("userRole"); // Expected to be "Admin"
  const location = useLocation(); // Get the current route
  const isPlanYourTrip = location.pathname === '/plan-your-trip'; // Check if the current route matches
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const [destinations, setDestinations] = useState([]);
  const [filteredDestinations, setFilteredDestinations] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [filteredAmenities, setFilteredAmenities] = useState([]);
  const[experiences,setExperiences]  = useState([]);
  const [filteredExperiences,setFilteredExperiences]  = useState([]);
  const [plans, setPlans] = useState([]);
  const [planMarkersVisible, setPlanMarkersVisible] = useState(false);
  const [planMarkers, setPlanMarkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [markers, setMarkers] = useState([]);
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const [visiblePlanId, setVisiblePlanId] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const [showFavorites, setShowFavorites] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const menuRef = useRef(null);
  const favoritesRef = useRef(null);
  const menuButtonRef = useRef(null);
  const favoritesButtonRef = useRef(null);
  
  const toggleMenu = () => setShowMenu(!showMenu);
  const toggleFavorite = () => setShowFavorites(!showFavorites);
  const handleCategoryClick = (category) => {
    setActiveCategory(activeCategory === category ? null : category);
  };

  const isMobile = () => window.innerWidth <= 768;
  const [isModalOpen, setIsModalOpen] = useState(false); // Control modal open state

  const [draftPlan, setDraftPlan] = useState({
    planName: "",
    fields: [{ id: 1, value: "", selectedId: "", selectedName: "" }],
  });

  const openModal = () => {
    setIsModalOpen(true); // Open modal
  };

   const closeModal = () => {
    setIsModalOpen(false); // Close modal
     showPlanOnMap([]);
  };

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                menuRef.current && 
                !menuRef.current.contains(event.target) && 
                !menuButtonRef.current.contains(event.target)
            ) {
                setShowMenu(false);
            };

            if (
                favoritesRef.current &&
                !favoritesRef.current.contains(event.target) &&
                !favoritesButtonRef.current.contains(event.target)
            ) {
                setShowFavorites(false);
            };
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

  
    useEffect(() => {
      const fetchDestinations = async () => {
        try {
          const destinationsResponse = await fetch(`${BASE_URL}Destination`);
          const destinationsData = await destinationsResponse.json();
          const normalizedDestinations = destinationsData.map((destination) => ({
            ...destination,
            id: destination.id,
          }));
          setDestinations(normalizedDestinations);
          setFilteredDestinations(normalizedDestinations);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching destinations:', error);
        }
      };
  
      fetchDestinations();
    }, []);


    useEffect(() => {
      const fetchExperiences = async () => {
        try {
          const response = await fetch(`${BASE_URL}Experience`);
          const data = await response.json();
          const normalizedExp = data.map((experience) => ({
            ...experience,
            id: experience.id,
          }));
          setExperiences(normalizedExp);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching destinations:', error);
        }
      };
  
      fetchExperiences();
    }, []);

    useEffect(() => {
      const fetchAmenities = async () => {
        try {
          const response = await fetch(`${BASE_URL}Amenity`);
          const data = await response.json();
          const normalizedAmenities = data.map((amenity) => ({
            ...amenity,
            id: amenity.id,
          }));
          setAmenities(normalizedAmenities);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching destinations:', error);
        }
      };
  
      fetchAmenities();
    }, []);

    const handleFilterChange = (categories) => {
      setSelectedCategories(categories);
    
      if (categories.length === 0) {
        setFilteredDestinations(destinations);
        setFilteredAmenities(amenities);
        setFilteredExperiences(experiences);
      } else {
        const filteredDest = destinations.filter((destination) =>
          categories.includes(destination.id)
        );
        const filteredAmen = amenities.filter((amenity) =>
          categories.includes(amenity.id)
        );
        const filteredExp = experiences.filter((experience) =>
          categories.includes(experience.id)
        );
        setFilteredDestinations(filteredDest);
        setFilteredAmenities(filteredAmen);
        setFilteredExperiences(filteredExp);
      }
    
      // Clear existing markers from the map
      markers.forEach(marker => marker.setMap(null));
      setMarkers([]);
    };

    const openInfoWindowRef = useRef(null);

    const handleApiLoaded = async ({ map, maps }) => {
      mapRef.current = map;

      const fetchDestinationsByCategory = async (categoryId) => {
        try {
          const categoryIdString = String(categoryId); // Ensure categoryId is a string
          const response = await fetch( `${BASE_URL}Destination/getByCategory/${categoryId}`);
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }   
          const data = await response.json();

          return data;
        } catch (error) {
          if (error.message.includes('404')) {
            console.error(`Category ID not found: ${error.message}`);
          } else {
            console.error('Error fetching data:', error);
          }
          return [];
        }
      };
    
      const fetchAllDestinations = async (categories) => {
        const allDestinations = [];
        for (const categoryId of categories) {
          const categoryDestinations = await fetchDestinationsByCategory(categoryId);
          allDestinations.push(...categoryDestinations);
        }
        return allDestinations;
      };
    
      const fetchAmenitiesByCategory = async (categoryId) => {
        try {
          const categoryIdString = String(categoryId); // Ensure categoryId is a string
          const response = await fetch( `${BASE_URL}Amenity/getByCategory/${categoryId}`);

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          return data;
        } catch (error) {
          if (error.message.includes('404')) {
            console.error(`Category ID not found: ${error.message}`);
          } else {
            console.error('Error fetching data:', error);
          }
          return [];
        }
      };
    
      const fetchAllAmenities = async (categories) => {
        const allAmenities = [];
        for (const categoryId of categories) {
          const categoryAmenities = await fetchAmenitiesByCategory(categoryId);
          allAmenities.push(...categoryAmenities);
        }
        return allAmenities;
      };

      const fetchExperiencesByCategory = async (categoryId) => {
        try {
          const categoryIdString = String(categoryId); // Ensure categoryId is a string    
          const response = await fetch(
            `${BASE_URL}Experience/getByCategory/${categoryId}`);
       
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);           
          }
    
          const data = await response.json();
          return data;
        } catch (error) {
          if (error.message.includes('404')) {
            console.error(`Category ID not found: ${error.message}`);
          } else {
            console.error('Error fetching data:', error);
          }
          return [];
        }
      };
    
      const fetchAllExperiences = async (categories) => {
        const allExperiences = [];
        for (const categoryId of categories) {
          const categoryExperiences = await fetchExperiencesByCategory(categoryId);
          allExperiences.push(...categoryExperiences);
        }
        return allExperiences;
      };


      const createMarker = (item) => {
        const position = {
          lat: parseFloat(item.location.latitude),
          lng: parseFloat(item.location.longitude),
        };
    
        const marker = new maps.Marker({
          position,
          map,
          title: item.name[selectedLanguage], 
          icon: {
            url: mapMarker,
            scaledSize: new maps.Size(32, 32),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(16, 32), 
          },
        });
    
        const mainInfoWindow = new maps.InfoWindow({
          content: `
            <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; background-color: #fff; padding: 15px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); border: 1px solid #ddd; max-width: 300px;">
              <h3 style="margin: 0 0 10px 0; font-size: 16px; font-weight: bold; color:  #385963;">${item.name[selectedLanguage]}</h3>
              <p style="margin: 0 0 10px 0; font-size: 14px; line-height: 1.5; color: #555;">${item.description[selectedLanguage] || "No description available."}</p>
            </div>
          `,
        });
    
        marker.addListener("click", () => {
          if (openInfoWindowRef.current) {
            openInfoWindowRef.current.close();
          }
          mainInfoWindow.open(map, marker);
          openInfoWindowRef.current = mainInfoWindow;
        });
    

        const hoverInfoWindow = new maps.InfoWindow({
          content: `
            <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; padding: 10px;">
              <h3 style="margin: 0; font-size: 16px; font-weight: bold; color:  #385963;">${item.name[selectedLanguage]}</h3>
            </div>
          `,
        });
        // Add mouseover listener to open the InfoWindow
        marker.addListener("mouseover", () => {
          hoverInfoWindow.open(map, marker);
        });
      
        // Add mouseout listener to close the InfoWindow
        marker.addListener("mouseout", () => {
          hoverInfoWindow.close();
        });


        marker.setMap(map); // Ensure marker is added to the map
        return marker;
      };
    
      const allDestinations = await fetchAllDestinations(selectedCategories);
    
      const destinationMarkers = allDestinations.map((destination) =>
        createMarker(destination)
      );
    
      const allAmenities = await fetchAllAmenities(selectedCategories);
    
      const amenityMarkers = allAmenities.map((amenity) =>
        createMarker(amenity)
      );

      const allExperiences = await fetchAllExperiences(selectedCategories);
    
      const experienceMarkers = allExperiences.map((experience) =>
        createMarker(experience)
      );
    
      setMarkers([...destinationMarkers, ...amenityMarkers,...experienceMarkers]);
    };
    
    useEffect(() => {
      if (mapRef.current && window.google) {
        const maps = window.google.maps;
        handleApiLoaded({ map: mapRef.current, maps });
      }
    }, [filteredDestinations, filteredAmenities, filteredExperiences,selectedCategories, plans]);


    useEffect(() => {
        // Αυτός ο handler θα διαγράψει το guestPlan πριν κλείσει η καρτέλα ή ο browser
        const handleBeforeUnload = () => {
            localStorage.removeItem('guestPlan');
        };

        // Προσθέτουμε τον listener για την περίπτωση που κλείνει το παράθυρο ή η καρτέλα
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Καθαρισμός του event listener όταν το component απομακρύνεται (unmounts)
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);


const showPlanOnMap = (plan) => {
  if (!window.google || !mapRef.current) return [];
  if (!plan || !Array.isArray(plan.fields)) {
    console.warn('Invalid plan object:', plan);
    return [];
  }

  const maps = window.google.maps;

  const resolvedPoints = plan.fields.map((field) => {
    let sourceArray;
    if (field.type === 'destination') sourceArray = destinations;
    else if (field.type === 'amenity') sourceArray = amenities;
    else if (field.type === 'experience') sourceArray = experiences;

    const matched = sourceArray?.find(item => item.id === field.selectedId);

    return matched || field; 
  }).filter(Boolean);

  const newPlanMarkers = resolvedPoints.map((item, index) => {
    const position = {
      lat: parseFloat(item.location.latitude),
      lng: parseFloat(item.location.longitude),
    };

    const markerLabel = {
      text: `${index + 1}`,
      color: "white",
      fontSize: "14px",
      fontWeight: "bold"
    };

    const marker = new maps.Marker({
      position,
      map: mapRef.current,
      title: item.name?.[selectedLanguage] || item.name || 'Plan Point',
      label: markerLabel,
      icon: {
        path: maps.SymbolPath.CIRCLE,
        fillColor: '#385963',
        fillOpacity: 1,
        strokeColor: '#fff',
        strokeWeight: 2,
        scale: 16,
      },
    });

    const infoWindow = new maps.InfoWindow({
      content: `<div style="font-weight:bold; color:#333;">${item.name?.[selectedLanguage] || item.name}</div>`,
    });

    marker.addListener("click", () => {
      infoWindow.open(mapRef.current, marker);
    });

    return marker;
  });

  if (newPlanMarkers.length > 0) {
    const bounds = new maps.LatLngBounds();
    newPlanMarkers.forEach(marker => bounds.extend(marker.getPosition()));
    mapRef.current.fitBounds(bounds);
  }

  // You can remove the state setters here

  if (isMobile()) {
    closeModal();
  }

  return newPlanMarkers; // Return the markers instead of setting state here
};



const togglePlanMarkers = (plan) => {
  const markers = planMarkers || [];

  if (visiblePlanId === plan.id) {
    // Hide current plan markers
    markers.forEach(marker => marker.setMap(null));
    setPlanMarkers([]);
    setVisiblePlanId(null);
  } else {
    // Hide old markers
    if (markers.length > 0) {
      markers.forEach(marker => marker.setMap(null));
    }

    // Show new plan markers
    const newMarkers = showPlanOnMap(plan) || [];
    setPlanMarkers(newMarkers);
    setVisiblePlanId(plan.id);
  }
};


const showFavoriteOnMap = (favorite) => {
  if (!window.google || !mapRef.current) return;

  const maps = window.google.maps;

  // Clear existing planMarkers if needed
  planMarkers.forEach(marker => marker.setMap(null));

  const position = {
    lat: parseFloat(favorite.location.latitude),
    lng: parseFloat(favorite.location.longitude),
  };

  const marker = new maps.Marker({
    position,
    map: mapRef.current,
    title: favorite.name?.[selectedLanguage] || favorite.name || 'Favorite Spot',
    icon: {
      url: heart, // your imported heart SVG path
      scaledSize: new maps.Size(40, 40), // adjust size
      anchor: new maps.Point(15, 15),    // center anchor
    },
  });

  const infoWindow = new maps.InfoWindow({
    content: `<div style="font-weight:bold; color:#333;">${favorite.name?.[selectedLanguage] || favorite.name}</div>`,
  });

  marker.addListener("click", () => {
    infoWindow.open(mapRef.current, marker);
  });

  setPlanMarkers([marker]);
};


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
    <Container>
    <MapContainer>
    <GoogleMapReact
          bootstrapURLKeys={{
              key: "AIzaSyCIrKrxTVDqlcRVFNyNMm5iS869G7RYvuc",
              language: selectedLanguage, // Dynamically set the map language
              region: selectedLanguage === 'en' ? 'EN' : undefined, 
          }}
          defaultZoom={11}
          defaultCenter={{
              lat: 40.0853,
              lng: 22.3584,
          }}
          onGoogleApiLoaded={handleApiLoaded}
          yesIWantToUseGoogleMapApiInternals
          options={{
            fullscreenControl: false,  
          }}
      ></GoogleMapReact>
    </MapContainer>
    <OverlayContainer>
      <FilterButton onFilterChange={handleFilterChange} />
       {isPlanYourTrip && <PlanYourTripButton
          onClick={openModal}
        >
        {i18n.t('planYourTrip')}
       </PlanYourTripButton>}
    </OverlayContainer>
  
    {isModalOpen && 
      <TripPlanModal 
        isOpen={isModalOpen} 
        onClose={closeModal}   
        destinations={destinations} 
        experiences={experiences}
        amenities={amenities} 
        onShowPlanOnMap={showPlanOnMap} 
        savedPlans={plans} 
        togglePlanMarkers={togglePlanMarkers}
        planMarkersVisible={visiblePlanId}
        draftPlan={draftPlan}
        setDraftPlan={setDraftPlan}
      />
    }

   {isPlanYourTrip && loggedIn && userRole==='RegisteredUser' &&( 
    <FavoriteButton ref={favoritesButtonRef} onClick={toggleFavorite}>
      <FavoriteText>{i18n.t('favorites')}</FavoriteText> {showFavorites ? '❤️' : '🤍'}
    </FavoriteButton>
    )}

    {showFavorites && (
     <FavoritesDropdown
       show={showFavorites}
       activeCategory={activeCategory}
       handleCategoryClick={handleCategoryClick}
       onFavoriteClick={showFavoriteOnMap}  
      />
    )}

  </Container>
    );
}

export default MainMap;



